import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import hardSet from "redux-persist/lib/stateReconciler/hardSet";

export const persistorConf = {
  key: "lavoris",
  storage,
  stateReconciler: hardSet,
};
